import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { changeColorState, changeNumberState, changeStringState } from "./common_modifiers/properyModifiers"
//import { Transform } from "../geometry/transformation";
import { shapeDefaults, ShapeDefaults } from "./shapeDefaults";
import { Transform } from "../geometry/transformation";


export interface BoundingBox {
    min: Point2d
    max: Point2d
}
export interface ModelState {
    boundingbox: BoundingBox;
    currentID: number,
    model: ModelData;
    selected: editorSelection,
}

export const validShapeTypes = ["line", "circle", "polyline", "text", "symbol", "rect", "polygon"] as const;

const calcBoundingbox = (model: ModelData): BoundingBox => {
    let xMax = Number.MIN_SAFE_INTEGER;
    let yMax = Number.MIN_SAFE_INTEGER;
    let xMin = Number.MAX_SAFE_INTEGER;
    let yMin = Number.MAX_SAFE_INTEGER;

    //model.shapes.forEach(element => {
        //TODO dont run it all the time (mutiple transforms etc)
        // const tr = new Transform(element.transformation)
        // const corners = [
        //     { x: 0, y: 0 },
        //     { x: 0, y: element.height },
        //     { x: element.width, y: element.height },
        //     { x: element.height, y: 0 }]

        // console.log("box", corners, element.type);

        for (const element of model.shapes) {
            //tr.point2d(element.boundingboxPosition);
            // if (element?.boundingboxPosition) {
            //     xMax = Math.max(xMax, (element.boundingboxPosition.x + element.width));
            //     yMax = Math.max(yMax, (element.boundingboxPosition.y + element.height));
            //     xMin = Math.min(xMin, (element.boundingboxPosition.x));
            //     yMin = Math.min(yMin, (element.boundingboxPosition.y));
            // } else throw new Error(`Shape with id:${element.id} not boxable`)

            if (element.type === "line" || element.type === "polyline" || element.type === "polygon") {
                const transformer = new Transform(element.transformation);
                for (const p of element.points) {
                    const transformed = transformer.point2d(p);
                    xMax = Math.max(xMax, transformed.x);
                    yMax = Math.max(yMax, transformed.y);
                    xMin = Math.min(xMin, transformed.x);
                    yMin = Math.min(yMin, transformed.y);
                }
            }
        }
        // for (const corner of corners.map((e) => tr.point2d(e))) {
        //     xMax = Math.max(xMax, corner.x ?? xMax);
        //     yMax = Math.max(yMax, corner.y ?? yMax);
        //     xMin = Math.min(xMin, corner.x ?? xMin);
        //     yMin = Math.min(yMin, corner.y ?? yMin);
        //     // console.log("element x,y",yMin, yMax, xMin, xMax);

        // }
    //});
    //  console.log(yMin, yMax, xMin, xMax);
    return { min: { x: xMin, y: -yMax }, max: { x: xMax, y: -yMin } }
}

const initialState: ModelState = {
    boundingbox: {
        min: { x: 0, y: 0 },
        max: { x: 2000, y: 2000 },
    },
    currentID: 0,
    model: { shapes: [], projectInformation: {} },
    selected: { selectedItemIds: [], selectedGroup: [] },
}

export const modelSlice = createSlice({
    name: 'model',
    initialState,
    reducers: {
        modelReset: (state) => {
            //state.boundingbox = calcBoundingbox(initialState.model)
            return initialState;
        },
        init: (state, action: PayloadAction<{ model: ModelData }>) => {
            state.model = { shapes: [], projectInformation: {} };

            state.model = {
                shapes: action.payload.model.shapes.map((s) => {
                    const key: keyof ShapeDefaults = s.type === "polyline" || s.type === "rect" ? "line" : s.type;
                    const def = shapeDefaults[key]
                    const out = { ...def, ...s }
                    return out
                }),
                projectInformation: {}
            }

            state.model.shapes.map((s: GeometricShape) => s.transformation = s.transformation ? s.transformation : [
                [1, 0, 0, 0],
                [0, 1, 0, 0],
                [0, 0, 1, 0],
                [0, 0, 0, 1]]);
            state.boundingbox = calcBoundingbox(state.model)
            console.log("init", state.boundingbox);
            state.model.projectInformation = action.payload.model.projectInformation;
            const ids = action.payload.model.shapes.map((x) => x.id);
            state.currentID = Math.max(...ids) + 1;
        },
        insertShape: (state, action: PayloadAction<GeometricShape>) => {
            console.log(new Date());
            //state.selected.selectedItemIds.push(state.currentID); // push this ID to the selection
            state.model.shapes.push({ ...action.payload, id: state.currentID++ });
            console.log(new Date());
            state.boundingbox = calcBoundingbox(state.model);
            console.log(new Date());
            console.log("insertShape", state.boundingbox);
        },
        removeSnappingPoint(state, action: PayloadAction<{ id: number, pointId: number }>) {
            const { id, pointId } = action.payload;
            const shapeIndex = findIndexById(state, id)
            if (shapeIndex !== undefined) {
                state.model.shapes[shapeIndex].snapPoint?.splice(pointId, 1)
                console.log(state.model.shapes[shapeIndex].snapPoint?.map((_) => { return { x: _.x, y: _.y } }));

            } else throw new Error("snappingPoint remove fail, index not found");
        },

        insertingSnappingPoint(state, action: PayloadAction<{ id: number, pointId: number, point: Point2d }>) {
            const { id, pointId, point } = action.payload;
            const shapeIndex = findIndexById(state, id)
            if (shapeIndex !== undefined) {
                const shapesSnappingPoints = state.model.shapes[shapeIndex].snapPoint;
                if (shapesSnappingPoints) {
                    state.model.shapes[shapeIndex].snapPoint = shapesSnappingPoints
                        .slice(pointId, 1)
                        .concat(point)
                        .concat(shapesSnappingPoints.slice(pointId, shapesSnappingPoints.length))
                }
            } else throw new Error("snappingPoint insertion fail, index not found");
        },

        modelReplaceMultipleShapes: (state, action: PayloadAction<GeometricShape[]>) => {
            for (const shape of action.payload) {
                const find = state.model.shapes.findIndex((value: GeometricShape) => value.id === shape.id);
                state.model.shapes[find] = shape;
                console.log("modelReplaceMultipleShapes-entity",find, state.model.shapes[find].type, state.model.shapes[find].width, state.model.shapes[find].height, state.model.shapes[find].position);
            }
            state.boundingbox = calcBoundingbox(state.model);
            console.log("modelReplaceMultipleShapes", state.boundingbox);
        },
        modelUpdateBoundingbox: (state, action: PayloadAction<{ pos: Point2d, size: { width: number, height: number }, id: number } | undefined>) => {
            if (action.payload) {
                const payload = action.payload;
                const find = state.model.shapes.findIndex((value: GeometricShape) => value.id === payload.id);
                state.model.shapes[find].width = payload.size.width;
                state.model.shapes[find].height = payload.size.height;
                state.model.shapes[find].position = payload.pos;
                console.log("modelUpdateBoundingbox", find, state.model.shapes[find].type, state.model.shapes[find].width, state.model.shapes[find].height, state.model.shapes[find].position);
            }
        },
        replaceShape: (state, action: PayloadAction<GeometricShape>) => {
            // console.log("replace shape", action.payload);
            const find = state.model.shapes.findIndex((value: GeometricShape) => value.id === action.payload.id);
            // console.log("régi", state.model.shapes[find]);

            state.model.shapes[find] = action.payload;
            state.boundingbox = calcBoundingbox(state.model);
            console.log("replaceShape", find, state.model.shapes[find].type, state.model.shapes[find].width, state.model.shapes[find].height, state.model.shapes[find].position);
        },
        modelAddMultipleItemToSelection: (state, action: PayloadAction<number[]>) => {
            const set = new Set(state.selected.selectedItemIds)
            action.payload.forEach((id) => { set.add(id) })
            state.selected.selectedItemIds = Array.from(set);
        },
        addItemToSelection: (state, action: PayloadAction<number>) => {
            const set = new Set(state.selected.selectedItemIds)
            set.add(action.payload);
            state.selected.selectedItemIds = Array.from(set);
        },
        removeItemFromSelection: (state, action: PayloadAction<number>) => {
            state.selected.selectedItemIds = state.selected.selectedItemIds.filter((value) => value !== action.payload)
        },
        modelSplitShapes: (state, action: PayloadAction<GeometricShape[]>) => {
            console.log("shape to replace", action.payload);

            let replaced: number[] = [];
            for (const shape of action.payload) {
                console.log(replaced);

                if (replaced.find((storedId) => storedId === shape.id) !== undefined) {
                    console.log("insert", shape);

                    modelSlice.caseReducers.insertShape(state, { payload: shape, type: "" })
                } else {
                    modelSlice.caseReducers.replaceShape(state, { payload: shape, type: "" })
                    console.log("replace", shape);
                    replaced.push(shape.id)
                }
            }
        },
        exitSelection: (state) => {
            state.selected = {
                selectedItemIds: [],
                selectedGroup: []
            };
        },
        changeNumberValue: (state, action: PayloadAction<{ id: number, propertyValue: number, propertyName: string }>) => {

            const find = state.model.shapes.findIndex((shape: GeometricShape) => shape.id === action.payload.id);
            if (find >= 0) {
                state.model.shapes[find] = changeNumberState(state.model.shapes[find], action)
            }
        },
        changeColorValue: (state, action: PayloadAction<{ id: number, propertyValue: ColorValue, propertyName: string }>) => {

            const find = state.model.shapes.findIndex((shape: GeometricShape) => shape.id === action.payload.id);
            if (find >= 0) {
                state.model.shapes[find] = changeColorState(state.model.shapes[find], action)
            }
        },
        changeImageValue: (state, action: PayloadAction<{ id: number, propertyValue: string, propertyName: string }>) => {

            const find = state.model.shapes.findIndex((shape: GeometricShape) => shape.id === action.payload.id);
            if (find >= 0) {
                state.model.shapes[find] = changeStringState(state.model.shapes[find], action)
            }
        },
        moveFromOneLayerToAnother: (state, action: PayloadAction<{ deleteId: number, moveToId: number }>) => {
            const whatToMove = state.model.shapes.filter((i: GeometricShape) => i.layerId === action.payload.deleteId);
            whatToMove.forEach(m => m.layerId = action.payload.moveToId)
        },
        changeLineType: (state, action: PayloadAction<{ id: number, propertyValue: number, propertyName: string }>) => {
            const find = state.model.shapes.findIndex((shape: GeometricShape) => shape.id === action.payload.id);
            if (find >= 0) {
                state.model.shapes[find] = changeNumberState(state.model.shapes[find], action);
            }
        },
        changeStringValue: (state, action: PayloadAction<{ id: number, propertyValue: string, propertyName: string }>) => {
            const find = state.model.shapes.findIndex((shape: GeometricShape) => shape.id === action.payload.id);
            if (find >= 0) {
                state.model.shapes[find] = changeStringState(state.model.shapes[find], action);
            }
        },
        deleteShape: (state, action: PayloadAction<number | number[]>) => {

            state.model.shapes = state.model.shapes.filter(
                (shape: GeometricShape) => {
                    if (Array.isArray(action.payload)) {
                        return action.payload.find((p) => shape.id === p) === undefined;
                    }
                    return shape.id !== action.payload
                }
            );
            state.boundingbox = calcBoundingbox(state.model);
            console.log("deleteShape", state.boundingbox);
        },
        deleteShapesFromLayer: (state, action: PayloadAction<{ deleteLayerId: number }>) => {
            state.model.shapes = state.model.shapes.filter((s: GeometricShape) => s.layerId !== action.payload.deleteLayerId)
        },
        deleteSelected: (state) => {
            state.model.shapes = state.model.shapes.filter(
                (shape: GeometricShape) => {
                    if (state.selected.selectedItemIds.length > 1) {
                        return state.selected.selectedItemIds.find((p) => shape.id === p) === undefined;
                    } else {
                        return shape.id !== state.selected.selectedItemIds[0]
                    }
                }

            );
            state.boundingbox = calcBoundingbox(state.model);
            console.log("deleteSelected", state.boundingbox);
        },
        changeFontStyle: (state, action: PayloadAction<{ shape: GeometricShape, option: string }>) => {
            const shape = action.payload.shape;
            const option = action.payload.option;
            if (shape.type === "text") {
                const index = state.model.shapes.findIndex((s: GeometricShape) => s.id === shape.id)
                const targetShape = state.model.shapes[index];
                if (targetShape.type === "text") {
                    const searchResult = targetShape.fontStyle.search(option);
                    if (searchResult < 0) {
                        targetShape.fontStyle = targetShape.fontStyle.concat(option + " ");
                    } else {
                        targetShape.fontStyle = targetShape.fontStyle.replace(option, "");
                    }
                }
            } else { console.error("wrong shape type") }
            //state.model.shapes.find().
        },
    }
})

function findIndexById(state: ModelState, id: number): number | undefined {
    const find = state.model.shapes.findIndex((value: GeometricShape) => value.id === id);
    return (find >= 0) ? find : undefined;
}
export const modelUndoExcludeAction = [
    modelSlice.actions.modelUpdateBoundingbox.type,
    modelSlice.actions.insertingSnappingPoint.type,
    modelSlice.actions.removeSnappingPoint.type,
]

export const {
    modelUpdateBoundingbox,
    deleteShapesFromLayer,
    moveFromOneLayerToAnother,
    modelReset,
    init,
    insertShape,
    addItemToSelection,
    modelAddMultipleItemToSelection,
    removeItemFromSelection,
    exitSelection,
    replaceShape,
    modelReplaceMultipleShapes,
    changeNumberValue,
    changeColorValue,
    changeImageValue,
    deleteSelected,
    removeSnappingPoint,
    changeLineType,
    changeStringValue,
    changeFontStyle,
    insertingSnappingPoint,
    modelSplitShapes,
    deleteShape,
} = modelSlice.actions

export { calcBoundingbox }
export default modelSlice.reducer

